import { changeRangeValueAction } from './changeRangeValueAction';

export const changePriceMaxAction = (value: number): ReturnType<typeof changeRangeValueAction> =>
  changeRangeValueAction({ fieldName: 'price', rangeValueKey: 'max', value });
